var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseModal',{attrs:{"is-mini":"","name":"languages"}},[_c('div',{staticClass:"language-picker"},[_c('h2',[_vm._v(_vm._s(_vm.$l10n('select-language')))]),_vm._l((_vm.languages),function(language){return _c('a',{key:language.slug,class:{
        'language-picker__option': true,
        'is-current': _vm.currentLanguage === language,
      },on:{"click":function($event){return _vm.changeLang(language.slug)}}},[_vm._v(_vm._s(language.name))])})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }